// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99dcf01f","553":"941afc45","644":"9895d3c1"}[chunkId] + ".chunk.js";
};